import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'selection-list',
    components: {
    },
})

export default class SelectionList extends Vue {

    @Prop()
    private list: any;

    @Prop()
    private item: any;

    @Prop()
    private displayFor: any;

    @Prop()
    private classificationList: any;

    @Prop({ default: {} })
    private selectedItemByCat: any = {};

    private selectedRecentItem: any = {};

    @Prop()
    private selectedItemDisplayList: any;

    get filteredItems() {
        if (this.list && this.list.length === 0) {
            return [];
        }
        return this.list.filter((item: any) => {
            return item;
        });
    }

    @Watch('selectedItemByCat', { deep: true })
    private checkByCategory(value: any) {
        this.selectedRecentItem = value;
    }

    @Watch('selectedItemDisplayList', { deep: true })
    private checkHeader(value: any) {
        this.checkForHeaderCheck(value);
    }

    private created() {
        this.item.selectedItem = [];
    }

    private onClick(item: any) {
        this.selectedRecentItem = item;
        this.$emit('onClick', item, this.item.modelKey);
    }

    private onCheck(item: any, activeFor?: any) {
        const isChecked = item.checked;
        if (this.item.modelKey === 'classification') {
            item.indeterminate = false;
            this.$emit('onCheck', item, this.item.modelKey);
            this.findAddRemove(item, this.item, isChecked, 'classification');
            for (const iterator of item.subjects) {
                iterator.checked = isChecked;
                this.$emit('onCheck', iterator, 'subject');
            }
        }
        if (this.item.modelKey === 'subject') {
            this.$emit('onCheck', item, this.item.modelKey);
            setTimeout(() => {
                let filterList = [];
                filterList = this.item.itemList.filter((checkedItem: any) => checkedItem.checked);
                if (this.item.itemList.length && filterList.length > 0) {
                    if (filterList.length !== this.item.itemList.length) {
                        this.$emit('onParent', item);
                    } else if (this.item.itemList.length === 1 && filterList.length === 1) {
                        this.$emit('onParent', item);
                    }
                }
            }, 500);
        }
        this.checkParentWise();
    }

    private iterationOnParent(listItem: any, parent: any) {
        if (parent === 'classification') {
            const idSplit = listItem.id.split('.');
            const classificationIndex = this.classificationList[parent].itemList.
                findIndex((item: any) => item.id === listItem.id);
            const uncheckItem = this.item.itemList.
                filter((item: any) => !item.checked) || [];
            let selectedItem = -1;
            if (this.classificationList[parent].selectedItem && this.classificationList[parent].selectedItem[parent]
                && this.classificationList[parent].selectedItem[parent].length) {
                selectedItem = this.classificationList[parent].selectedItem[parent].
                    findIndex((item: any) => item.id === listItem.id);
            }
            if (selectedItem === -1 && (listItem.checked || listItem.indeterminate)) {
                if (classificationIndex !== -1) {
                    let isIndeterminate = false;
                    let isChecked = false;
                    if (this.item.itemList.length === uncheckItem.length) {
                        isIndeterminate = false;
                        isChecked = true;
                    } else if (this.item.itemList.length > uncheckItem.length) {
                        isIndeterminate = true;
                        isChecked = false;
                    }
                    this.classificationList[parent].itemList[classificationIndex].indeterminate = isIndeterminate;
                    this.$emit('indeterminateCheck', this.classificationList[parent].itemList[classificationIndex], 'classification', classificationIndex, listItem);
                }
            }
        } else if (parent === 'subject') {
            const idSplit = listItem.id.split('.');
            const subjectId = `${idSplit[1]}.${idSplit[1]}`;
            const classificationID = listItem.parentId;
            const subjectIndex = this.classificationList[parent].itemList.
                findIndex((item: any) => item.id === subjectId);
            const uncheckItem = this.item.itemList.filter((item: any) => !item.checked) || [];
            let selectedItem = -1;
            if (this.classificationList[parent].selectedItem && this.classificationList[parent].selectedItem[parent]
                && this.classificationList[parent].selectedItem[parent].length) {
                selectedItem = this.classificationList[parent].selectedItem[parent].
                    findIndex((item: any) => item.id === subjectId);
            }
            if (selectedItem === -1 && (listItem.checked || listItem.indeterminate)) {
                if (subjectIndex !== -1) {
                    let isIndeterminate = false;
                    let isChecked = false;
                    if (this.item.itemList.length === uncheckItem.length) {
                        isIndeterminate = false;
                        isChecked = true;
                    } else if (this.item.itemList.length > uncheckItem.length) {
                        isIndeterminate = true;
                        isChecked = false;
                    }
                    this.classificationList[parent].itemList[subjectIndex].indeterminate = isIndeterminate;
                    this.$emit('indeterminateCheck',
                        this.classificationList[parent].itemList[subjectIndex], 'subject', subjectIndex, listItem);
                }
            }
        }
    }

    private onAll(value: any) {
        if (value) {
            this.checkUncheckAll(value);
        } else {
            this.checkUncheckAll(false);
        }
    }

    private checkUncheckAll(isSelect: boolean) {
        if (this.item.modelKey === 'classification') {
            // this.resetIndeterminate();
            for (const iterator of this.list) {
                iterator.checked = isSelect;
                iterator.indeterminate = false;
                this.findAddRemove(iterator, this.item, isSelect, 'classification');
                for (const sub of iterator.subjects) {
                    sub.checked = isSelect;
                    sub.indeterminate = false;
                    this.findAddRemove(sub, this.classificationList.subject, isSelect, 'subject');
                    // for (const fw of sub.frameworks) {
                    //     fw.checked = isSelect;
                    //     this.findAddRemove(fw, this.classificationList.framework, isSelect, 'framework');
                    // }
                }
            }
            this.$emit('resetIndeterminate');
        } else if (this.item.modelKey === 'subject') {
            for (const iterator of this.list) {
                iterator.checked = isSelect;
                iterator.indeterminate = false;
                this.findAddRemove(iterator, this.classificationList.subject, isSelect, 'subject');
            }
        }
        this.checkParentWise();

    }

    private parentIdWise() {
        const emptyList = this.list.reduce((r: any, a: any) => {
            const sliptArray = a.id.split('.');
            if (sliptArray.length === 3) {
                const parentId = `${sliptArray[1]}.${sliptArray[2]}`;
                r[parentId] = r[parentId] || [];
                r[parentId].push(a);
            } else if (sliptArray.length === 2) {
                const parnetCode = `${sliptArray[0]}`;
                r[parnetCode] = r[parnetCode] || [];
                r[parnetCode].push(a);
            } else if (sliptArray.length === 1) {
                const classificaiton = 'classificaiton';
                r[classificaiton] = r[classificaiton] || [];
                r[classificaiton].push(a);
            }
            return r;
        }, Object.create(null));

        return emptyList;
    }

    private findAddRemove(obj: any, list: any, isAdd: boolean, displayFor: any) {
        const itemIndex = list.selectedItem.findIndex((item: any) => item.id === obj.id);
        if (isAdd) {
            if (itemIndex === -1) {
                list.selectedItem.push(obj);
            }
        } else if (!isAdd) {
            if (itemIndex !== -1) {
                list.selectedItem.splice(itemIndex, 1);
            }
        }
    }

    private checkParentWise() {
        setTimeout(() => {
            this.$emit('checkParentWise');
        }, 1000);
    }

    private checkForHeaderCheck(displayFor: any) {
        // if (this.selectedItemDisplayList.length === 0) {
        //     this.item.indeterminate = false;
        //     this.item.checked = false;
        // // }
        // console.log('this.item', this.item , this.displayFor, this.selectedItemDisplayList);

        // if (this.selectedItemDisplayList.length) {
        //     if (this.item.itemList.length) {
        //         if (this.selectedItemDisplayList.length === this.item.itemList.length) {
        //             this.item.indeterminate = false;
        //             this.item.checked = true;
        //         } else {
        //             this.item.indeterminate = true;
        //             this.item.checked = true;
        //         }
        //     } else {
        //         this.item.indeterminate = false;
        //         this.item.checked = false;
        //     }
        // } else {
        //     this.item.indeterminate = false;
        //     this.item.checked = false;
        // }
    }
}
